<template>
  <div class="quiz__nav">
    <nav-button
      v-if="showP"
      :caption="previous"
      @clicked="$emit('back')"
      class="back"
      :uppercase="true"
      size="big"
    />
    <nav-button
      v-if="showN"
      :caption="next"
      @clicked="$emit('next')"
      class="next"
      :uppercase="true"
      size="big"
    />
  </div>
</template>
<script>
import NavButton from "../components/NavButton.vue";

export default {
  name: "QuestionsNav",
  components: {
    NavButton: NavButton
  },
  props: {
    showN: {
      type: Boolean,
      default: true
    },
    showP: {
      type: Boolean,
      default: true
    },
    previous: {
      type: String,
      default: "Back"
    },
    next: {
      type: String,
      default: "Next"
    }
  }
};
</script>